// extracted by mini-css-extract-plugin
export default {"wave":"MPJ57","light":"fLz6O","gray":"NKS0D","autoWidth":"Cz1UT"};